import request from "../utils/request";

export function getDSARNotifications(company) {
  let query = "";
  if (company !== undefined) {
    query += `?company=${company}`;
  }
  return request({
    url: `/dsar/notifications${query}`,
    method: "get",
  });
}

export function getDSARList(pagination) {
  return request({
    url: `/dsar`,
    method: "get",
    params: pagination,
  });
}

export function getDSAR(id) {
  return request({
    url: `/dsar/${id}`,
    method: "get",
  });
}

export function createDSAREvent(id, data) {
  return request({
    url: `/dsar/${id}/events`,
    method: "post",
    data,
  });
}

export function getDSAREvents(id) {
  return request({
    url: `/dsar/${id}/events`,
    method: "get",
  });
}

export function createDSARMonitoring(id, data) {
  return request({
    url: `/dsar/${id}/monitoring`,
    method: "post",
    data,
  });
}

export function getDSARMonitoring(id) {
  return request({
    url: `/dsar/${id}/monitoring`,
    method: "get",
  });
}

export function setDSARMonitoringVisibility(monitoring, hidden) {
  return request({
    url: `/dsar/${monitoring.complaint}/monitoring/${monitoring._id}`,
    method: "post",
    data: {
      hidden,
    },
  });
}

export function setDSARMonitoringResponseEnabled(complaint, enabled) {
  return request({
    url: `/dsar/${complaint._id}/monitoring-response`,
    method: "post",
    data: {
      enabled,
    },
  });
}

export function classifyDSAR(id, data) {
  return request({
    url: `/dsar/${id}/classification`,
    method: "patch",
    data,
  });
}
